import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { DEFAULT_HOME_ROUTE } from '../../../config/navAccessMap';

const PublicRoute = ({ children }) => {
  const { user, initialized } = useAuthContext();

  // Only block on initial session restore — not during login/register API calls.
  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return user ? <Navigate to={DEFAULT_HOME_ROUTE} replace /> : children;
};

export default PublicRoute;
